import { _clientNow, _unixToClientTime } from '@/functions/timezone';
import useTokenStore from '@/modules/auth/stores/useTokenStore';
import config from '@/modules/config/functions/config';
import { isNil } from 'lodash-es';

export default function isAccessTokenStillValid(
  threshold = config(
    'features.auth.accessTokenSoftExpirationThreshold',
    5 * 24 * 60 * 60 * 1000
  )
) {
  const expiresAt = _unixToClientTime(
    useTokenStore.getState()._accessTokenExpiresAt ?? 0
  );
  if (isNil(expiresAt)) return false;
  return _clientNow().isBefore(expiresAt.subtract(threshold, 'milliseconds'));
}
